import React from "react";
import { FiCheck } from "react-icons/fi";
import "./InvestorListView.scss";

const InvestorListView = ({ 
  investors, 
  theme, 
  toggleInvestorSelection, 
  selectedInvestors 
}) => {
  if (!investors || investors.length === 0) {
    return (
      <div className="noInvestors">
        <p>No investors in this list yet.</p>
      </div>
    );
  }

  return (
    <div className={`investorListView ${theme}`}>
      {investors.map((investor) => (
        <div 
          key={investor._id} 
          className={`investorCard ${selectedInvestors.includes(investor._id) ? 'selected' : ''}`}
        >
          <div className="investorInfo">
            <div className="investorAvatar">
              {investor.profilePicture ? (
                <img src={investor.profilePicture} alt={`${investor.firstName} ${investor.lastName}`} />
              ) : (
                <div className="avatarPlaceholder">
                  {investor.firstName?.charAt(0) || ''}
                  {investor.lastName?.charAt(0) || ''}
                </div>
              )}
            </div>
            <div className="investorDetails">
              <h3>{investor.firstName} {investor.lastName} <span className="investorCompany">({investor.companyName})</span></h3>
              <p className="investorTitle">{investor.title || 'Investor'}</p>
              <p className="investorLocation">{investor.location || 'Location not specified'}</p>
            </div>
          </div>
          <div className="investorActions">
            <button 
              className={`selectButton ${selectedInvestors.includes(investor._id) ? 'selected' : ''}`}
              onClick={() => toggleInvestorSelection(investor._id)}
            >
              {selectedInvestors.includes(investor._id) ? (
                <>
                  <FiCheck /> Selected
                </>
              ) : (
                'Select'
              )}
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default InvestorListView; 